
// types of action
const Types = {
  AUDIT_LOG_VIEW_DETAIL: "AUDIT_LOG_VIEW_DETAIL",
};

const showAuditLogDetail = ({show,item}) => ({
  type: Types.AUDIT_LOG_VIEW_DETAIL,
  show,
  item,
});


const Actions = {
  showAuditLogDetail
}

// exports = {
//   Types,
//   Actions
// }

export {Types, Actions}

// exports.Types = Types
// exports.Actions = Actions